import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maxChars'
})
export class MaxCharsPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    const maxLength = args[0];
    if (maxLength && value) {
      const newValue = (value + '').substr(0, maxLength);
      return newValue === value + '' ? value : newValue + '...';
    }
    return value;
  }

}
